var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeleteIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.851,
    height: 25.504,
    viewBox: "1747.03 499.788 21.851 25.504",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1749.353 507.509h17.345c.139-.006.278.006.415.033.226.05.433.162.598.324.192.184.313.43.341.694.005.1.001.2-.012.3l-1.478 15.302v.085c-.01.063-.023.126-.041.187v.013c-.16.494-.617.834-1.137.845h-14.754a1.282 1.282 0 0 1-.26-.04 1.282 1.282 0 0 1-.24-.099 1.284 1.284 0 0 1-.64-1.014l-1.455-15.27a1.598 1.598 0 0 1-.012-.344c.029-.26.149-.503.339-.684.171-.167.388-.28.623-.328.123-.021.247-.03.372-.027l-.004.023Zm-1.147-5.892h6.538v-.582a1.247 1.247 0 0 1 .366-.887c.233-.23.547-.36.875-.36h4.087a1.247 1.247 0 0 1 1.184 1.247v.582h6.729c.487.04.87.432.896.92v2.153c0 .297-.24.538-.538.538h-20.773a.538.538 0 0 1-.538-.532v-2.097a.98.98 0 0 1 .806-.966 2.16 2.16 0 0 1 .368-.016Zm8.747 10.95a.991.991 0 0 1 1.972 0v7.687a.991.991 0 0 1-1.972 0v-7.688Zm4.93-.042a.952.952 0 0 1 1.04-.844.929.929 0 0 1 .936.927l-.415 7.687a.95.95 0 0 1-1.04.844.929.929 0 0 1-.936-.927l.415-7.687Zm-9.657.083a.927.927 0 0 1 .935-.927.952.952 0 0 1 1.039.844l.416 7.687a.929.929 0 0 1-.938.927.95.95 0 0 1-1.038-.844l-.416-7.687Z",
    fill: "#707070",
    fillRule: "evenodd",
    "data-name": "delete-icon"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteIcon);
export default __webpack_public_path__ + "static/media/deleteIcon.1ee72034f9ec7a992b3ea2b92657ed93.svg";
export { ForwardRef as ReactComponent };